// extracted by mini-css-extract-plugin
export default {"wrapper":"Jv-z","button":"Kv-z","alternate":"Lv-z","disabled":"Mv-z","paymentWarning":"Nv-z","fadeIn":"Ov-z"};